export default "__VITE_ASSET__8e47e868__"